// src/pages/admin/AdminSolicitacoes.js

import React, { useEffect, useState } from 'react';
import { getSolicitacoes, updateStatusSolicitacao } from '../../services/api';
import { formatDate } from '../../utils/helpers';
import Toast from '../../components/common/Toast';

const STATUS_OPTIONS = ['Pendente', 'Em andamento', 'Concluído', 'Cancelado'];

const TIPO_LABEL = {
  batisterio:          'Batistério',
  declaracao:          'Declaração',
  declaracao_casamento:'Dec. Casamento',
};

const TIPO_STYLE = {
  batisterio:           { bg: '#e8eef7', color: '#1a3a6b' },
  declaracao:           { bg: '#f5e9c8', color: '#7d4e1e' },
  declaracao_casamento: { bg: '#eafaf1', color: '#1e7d4f' },
};

const AdminSolicitacoes = () => {
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [filtroStatus, setFiltroStatus] = useState('');
  const [filtroTipo, setFiltroTipo] = useState('');
  const [toast, setToast] = useState(null);

  const load = () => {
    getSolicitacoes().then(r => setSolicitacoes(r?.data || [])).catch(() => {});
  };
  useEffect(load, []);

  const handleStatus = async (id, status) => {
    try {
      await updateStatusSolicitacao(id, status);
      setToast({ msg: 'Status atualizado!', type: 'success' });
      load();
    } catch {
      setToast({ msg: 'Erro ao atualizar.', type: 'error' });
    }
  };

  const filtradas = solicitacoes.filter(s => {
    const okStatus = !filtroStatus || s.status === filtroStatus;
    const okTipo   = !filtroTipo   || s.tipo   === filtroTipo;
    return okStatus && okTipo;
  });

  return (
    <div style={{ padding: 'var(--space-2xl)' }}>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 'var(--space-xl)', flexWrap: 'wrap', gap: '1rem' }}>
        <div>
          <h2 style={{ marginBottom: '0.25rem' }}>Solicitações</h2>
          <p style={{ color: 'var(--gray-400)', fontSize: '0.9rem' }}>
            {filtradas.length} solicitaç{filtradas.length !== 1 ? 'ões' : 'ão'}
          </p>
        </div>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <select className="form-select" style={{ fontSize: '0.875rem', padding: '0.5rem 1rem' }}
            value={filtroTipo} onChange={e => setFiltroTipo(e.target.value)}>
            <option value="">Todos os tipos</option>
            <option value="batisterio">Batistério</option>
            <option value="declaracao">Declaração</option>
            <option value="declaracao_casamento">Dec. Casamento</option>
          </select>
          <select className="form-select" style={{ fontSize: '0.875rem', padding: '0.5rem 1rem' }}
            value={filtroStatus} onChange={e => setFiltroStatus(e.target.value)}>
            <option value="">Todos os status</option>
            {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
      </div>

      {filtradas.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '4rem', color: 'var(--gray-400)' }}>
          Nenhuma solicitação encontrada.
        </div>
      ) : (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>NOME</th>
                <th>TIPO / FINALIDADE</th>
                <th>CONTATO</th>
                <th>LOCAL / ANO BATISMO</th>
                <th>DATA</th>
                <th>STATUS</th>
                <th>DOCUMENTO</th>
              </tr>
            </thead>
            <tbody>
              {filtradas.map((s, i) => {
                const tipoStyle = TIPO_STYLE[s.tipo] || TIPO_STYLE.declaracao;
                const tipoLabel = TIPO_LABEL[s.tipo] || s.tipo || '—';

                // Para declaração de casamento, nome = noivo + noiva
                const nomeExibido = s.tipo === 'declaracao_casamento'
                  ? [s.nomeNoivo, s.nomeNoiva].filter(Boolean).join(' & ') || s.nome
                  : s.nome;

                return (
                  <tr key={i}>
                    {/* Nome */}
                    <td>
                      <strong style={{ fontSize: '0.875rem' }}>{nomeExibido || '—'}</strong>
                    </td>

                    {/* Tipo + Finalidade */}
                    <td>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
                        <span style={{
                          display: 'inline-block',
                          padding: '0.2rem 0.6rem',
                          borderRadius: '99px',
                          fontSize: '0.72rem',
                          fontWeight: 700,
                          background: tipoStyle.bg,
                          color: tipoStyle.color,
                          whiteSpace: 'nowrap',
                        }}>
                          {tipoLabel}
                        </span>
                        {s.finalidade && (
                          <span style={{ fontSize: '0.78rem', color: 'var(--gray-600)' }}>
                            {s.finalidade}
                          </span>
                        )}
                      </div>
                    </td>

                    {/* Contato */}
                    <td style={{ fontSize: '0.85rem' }}>{s.telefone || '—'}</td>

                    {/* Local/Ano Batismo ou dados casamento */}
                    <td style={{ fontSize: '0.85rem' }}>
                      {s.tipo === 'declaracao_casamento' ? (
                        <div>
                          {s.localCasamento && <div>{s.localCasamento}</div>}
                          {s.dataCasamento && (
                            <div style={{ fontSize: '0.78rem', color: 'var(--gray-400)' }}>
                              {formatDate(s.dataCasamento)}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div>
                          {s.localBatismo && <div>{s.localBatismo}</div>}
                          {s.anoBatismo && (
                            <div style={{ fontSize: '0.78rem', color: 'var(--gray-400)' }}>
                              Ano: {s.anoBatismo}
                            </div>
                          )}
                        </div>
                      )}
                    </td>

                    {/* Data */}
                    <td style={{ fontSize: '0.82rem', whiteSpace: 'nowrap' }}>
                      {s.dataCriacao ? formatDate(s.dataCriacao) : '—'}
                    </td>

                    {/* Status */}
                    <td>
                      <select value={s.status || 'Pendente'}
                        onChange={e => handleStatus(s.id, e.target.value)}
                        className="form-select"
                        style={{ fontSize: '0.8rem', padding: '0.35rem 0.5rem', minWidth: 120 }}>
                        {STATUS_OPTIONS.map(st => <option key={st} value={st}>{st}</option>)}
                      </select>
                    </td>

                    {/* Documento */}
                    <td>
                      {s.urlDocumento ? (
                        <a href={s.urlDocumento} target="_blank" rel="noopener noreferrer"
                          style={{ color: 'var(--navy)', fontSize: '0.82rem', display: 'flex', alignItems: 'center', gap: '0.3rem', whiteSpace: 'nowrap' }}>
                          📄 Ver Doc
                        </a>
                      ) : (
                        <span style={{ color: 'var(--gray-400)', fontSize: '0.82rem' }}>—</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminSolicitacoes;